/* SEOUL SKIN RITUALS — conversion layer: product-page purchase block (launch offer, purchase options, add-ons,
 * genuine low-stock note, sticky mobile bar) and the slide-out bag (shipping progress, recommendations, checkout CTA).
 * Data: window.SSR_CONVERSION (prototype: conversion-config.js; theme: snippet ssr-conversion-config with real Shopify
 * data). Cart: a session-only demo cart in the prototype, the Shopify Ajax Cart API in the theme.
 * Rules: no countdowns, no invented stock, no savings without a valid price rule, nothing shown when data is missing. */
(function () {
  var BASE = window.SSR_CONVERSION;
  if (!BASE) return;
  var demo = false;
  try { demo = !!(BASE.demo && BASE.demo.allowed) && new URLSearchParams(location.search).has('promo-demo'); } catch (e) { demo = false; }

  // ---------- configuration (demo values merged only in the demo view)
  var clone = function (o) { return JSON.parse(JSON.stringify(o)); };
  var C = clone(BASE); delete C.demo;
  if (demo) {
    var D = clone(BASE.demo);
    Object.keys(D).forEach(function (k) {
      if (k === 'catalogOverrides' || k === 'allowed') return;
      C[k] = (D[k] && typeof D[k] === 'object' && !Array.isArray(D[k]) && C[k] && typeof C[k] === 'object') ? Object.assign({}, C[k], D[k]) : D[k];
    });
    Object.keys(D.catalogOverrides || {}).forEach(function (h) { C.catalog[h] = Object.assign({}, C.catalog[h] || {}, D.catalogOverrides[h]); });
  }
  var isShopify = !!C.shopify;
  var num = function (v) { var n = typeof v === 'number' ? v : (typeof v === 'string' && /^\d+(\.\d{1,2})?$/.test(v.trim()) ? Number(v) : NaN); return isFinite(n) ? n : NaN; };
  var money = function (n) { try { return new Intl.NumberFormat('en-US', { style: 'currency', currency: C.currency || 'USD' }).format(n); } catch (e) { return '$' + Number(n).toFixed(2); } };
  var esc = function (s) { var d = document.createElement('div'); d.textContent = s == null ? '' : String(s); return d.innerHTML; };
  var product = function (h) { return C.catalog && C.catalog[h]; };
  var track = function (event, data) {
    if (C.analytics && C.analytics.enabled) { (window.dataLayer = window.dataLayer || []).push(Object.assign({ event: event }, data || {})); }
    else if (demo && window.console) console.debug('[analytics prepared, not sent]', event, data || {});
  };

  // ---------- launch offer (dates + valid previous price; no countdown, no auto-reset)
  var offerState = function (h) {
    var o = C.launchOffer || {}, p = product(h);
    if (!o.enabled || o.product !== h || !p) return null;
    var s = Date.parse(o.start || ''), e = Date.parse(o.end || ''), now = Date.now();
    if (!(isFinite(s) && isFinite(e) && s < e && now >= s && now <= e)) return null;
    var price = num(p.price), was = num(p.compareAt);
    if (!(price > 0 && was > price)) return null;
    var ends = '';
    try { ends = new Intl.DateTimeFormat('en-US', { month: 'long', day: 'numeric', year: 'numeric', hour: 'numeric', minute: '2-digit', timeZone: o.timezone || 'America/New_York', timeZoneName: 'short' }).format(new Date(e)); } catch (x) { ends = new Date(e).toDateString(); }
    var day = function (d) { try { return new Intl.DateTimeFormat('en-CA', { timeZone: o.timezone || 'America/New_York' }).format(d); } catch (x) { return d.toDateString(); } };
    var endsToday = day(new Date(now)) === day(new Date(e));
    return { price: price, was: was, pct: Math.round((was - price) / was * 100), endsToday: endsToday, ends: ends, label: o.label || 'Launch offer', terms: o.terms || '' };
  };
  var bundleState = function (b) {
    var sum = 0, ok = true;
    (b.items || []).forEach(function (h) { var p = product(h); var v = p && num(p.price); if (!(v > 0)) ok = false; else sum += v; });
    if (!ok || !b.items || b.items.length < 2) return null;
    var rule = num(b.price);
    return { sum: sum, price: rule > 0 && rule < sum ? rule : sum, saving: rule > 0 && rule < sum ? sum - rule : 0 };
  };

  // ---------- cart adapters
  var DemoCart = {
    key: 'ssr-demo-cart',
    read: function () { try { return JSON.parse(sessionStorage.getItem(this.key)) || []; } catch (e) { return []; } },
    write: function (l) { try { sessionStorage.setItem(this.key, JSON.stringify(l)); } catch (e) { /* demo only */ } },
    get: function () {
      var lines = this.read().map(function (l) {
        var p = product(l.handle) || {}, v = (p.variants || []).filter(function (x) { return x.id === l.variant; })[0];
        var unit = num(p.price) || 0;
        return { key: l.key, handle: l.handle, title: p.title || l.handle, variant: v ? v.title : '', image: (v && v.image) || p.image, url: p.url, qty: l.qty, unit: unit, line: unit * l.qty, bundle: l.bundle || '' };
      });
      var subtotal = lines.reduce(function (s, l) { return s + l.line; }, 0), discounts = [];
      (C.bundles || []).forEach(function (b) {
        var st = bundleState(b); if (!st || !st.saving) return;
        var sets = Math.min.apply(null, b.items.map(function (h) { return lines.filter(function (l) { return l.handle === h && l.bundle === b.id; }).reduce(function (s, l) { return s + l.qty; }, 0); }));
        if (sets > 0) discounts.push({ title: b.title + (demo ? ' (example rule)' : ''), amount: st.saving * sets });
      });
      var off = discounts.reduce(function (s, d) { return s + d.amount; }, 0);
      return Promise.resolve({ lines: lines, count: lines.reduce(function (s, l) { return s + l.qty; }, 0), subtotal: subtotal - off, discounts: discounts, total: subtotal - off });
    },
    add: function (items) {
      var l = this.read();
      items.forEach(function (it) {
        var key = it.handle + '|' + (it.variant || '') + '|' + (it.bundle || '');
        var ex = l.filter(function (x) { return x.key === key; })[0];
        if (ex) ex.qty += it.qty || 1; else l.push({ key: key, handle: it.handle, variant: it.variant || '', bundle: it.bundle || '', qty: it.qty || 1 });
      });
      this.write(l); return this.get();
    },
    change: function (key, qty) {
      var l = this.read().map(function (x) { if (x.key === key) x.qty = qty; return x; }).filter(function (x) { return x.qty > 0; });
      this.write(l); return this.get();
    }
  };
  var ShopifyCart = {
    map: function (c) {
      return {
        lines: c.items.map(function (i) { return { key: i.key, handle: i.handle, title: i.product_title, variant: i.variant_title && i.variant_title !== 'Default Title' ? i.variant_title : '', image: i.image, url: i.url, qty: i.quantity, unit: i.final_price / 100, line: i.final_line_price / 100, bundle: (i.properties || {})._bundle || '' }; }),
        count: c.item_count, subtotal: c.items_subtotal_price / 100, total: c.total_price / 100,
        discounts: (c.cart_level_discount_applications || []).map(function (d) { return { title: d.title, amount: d.total_allocated_amount / 100 }; })
      };
    },
    req: function (url, body) {
      return fetch(url, body ? { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) } : { headers: { Accept: 'application/json' } })
        .then(function (r) { if (!r.ok) throw new Error('cart ' + r.status); return r.json(); });
    },
    get: function () { var self = this; return this.req((C.routes && C.routes.cart || '/cart') + '.js').then(function (c) { return self.map(c); }); },
    add: function (items) {
      var self = this;
      var payload = { items: items.map(function (it) { var o = { id: it.variant, quantity: it.qty || 1 }; if (it.bundle) o.properties = { _bundle: it.bundle }; return o; }) };
      return this.req((C.routes && C.routes.cartAdd || '/cart/add') + '.js', payload).then(function () { return self.get(); });
    },
    change: function (key, qty) { var self = this; return this.req((C.routes && C.routes.cartChange || '/cart/change') + '.js', { id: key, quantity: qty }).then(function (c) { return self.map(c); }); }
  };
  var Cart = isShopify ? ShopifyCart : DemoCart;

  // ---------- demo label
  if (demo && !document.querySelector('.promo-demo-flag')) {
    var f = document.createElement('p'); f.className = 'promo-demo-flag'; f.setAttribute('role', 'note'); f.textContent = 'Promotion demo · not live'; document.body.appendChild(f);
  }

  // ---------- slide-out bag
  var drawer, panel, lastFocus;
  var shippingBox = function (sub) {
    var S = window.SSR_PROMO_STATE && window.SSR_PROMO_STATE.shipping;
    if (!S) return '';
    var left = Math.round((S.threshold - sub) * 100) / 100, pct = Math.min(100, Math.max(0, sub / S.threshold * 100));
    return '<div class="promo-ship' + (left <= 0 ? ' is-unlocked' : '') + '" aria-live="polite"><p class="promo-ship-msg">' +
      (left > 0 ? 'You’re ' + esc(money(left)) + ' away from complimentary shipping.' : 'You’ve unlocked complimentary shipping.') +
      '</p><div class="promo-ship-track" role="progressbar" aria-label="Progress to complimentary shipping" aria-valuemin="0" aria-valuemax="100" aria-valuenow="' + Math.round(pct) + '"><div class="promo-ship-fill" style="width:' + pct.toFixed(1) + '%"></div></div></div>';
  };
  var recs = function (cart) {
    var r = C.recommendations || {};
    if (!r.enabled || !r.products) return '';
    var inCart = cart.lines.map(function (l) { return l.handle; });
    var list = r.products.filter(function (h) { return inCart.indexOf(h) === -1 && product(h) && num(product(h).price) > 0; }).slice(0, 3);
    if (!list.length) return '';
    return '<section class="cv-recs" aria-labelledby="cv-recs-title"><h3 id="cv-recs-title">' + esc(r.title || 'You may also like') + '</h3><ul>' +
      list.map(function (h) { var p = product(h); return '<li><img src="' + esc(p.image) + '" alt="" loading="lazy"><div><p>' + esc(p.title) + '</p><span>' + esc(money(num(p.price))) + '</span></div>' +
        '<button type="button" class="cv-rec-add" data-cv-rec="' + esc(h) + '" aria-label="Add ' + esc(p.title) + ' to bag">Add</button></li>'; }).join('') + '</ul></section>';
  };
  var renderDrawer = function (cart) {
    if (!panel) return;
    var body = panel.querySelector('.cv-body'), foot = panel.querySelector('.cv-foot');
    panel.querySelector('[data-cv-count]').textContent = cart.count ? '(' + cart.count + ')' : '';
    if (!cart.lines.length) {
      body.innerHTML = '<div class="cv-empty"><p>Your bag is empty.</p><a class="text-button" href="' + esc(C.collectionUrl || 'collection-page.html') + '">Explore the collection <span aria-hidden="true">↗</span></a></div>';
      foot.innerHTML = ''; updateBadges(cart); return;
    }
    body.innerHTML = shippingBox(cart.subtotal) + '<ul class="cv-lines">' + cart.lines.map(function (l) {
      return '<li class="cv-line"><img src="' + esc(l.image) + '" alt=""><div class="cv-line-info"><a href="' + esc(l.url || '#') + '">' + esc(l.title) + '</a>' +
        (l.variant ? '<p>' + esc(l.variant) + '</p>' : '') + (l.bundle ? '<p class="cv-tag">Part of a set</p>' : '') +
        '<div class="cv-qty" role="group" aria-label="Quantity of ' + esc(l.title) + '"><button type="button" data-cv-qty="-1" data-key="' + esc(l.key) + '" aria-label="Decrease quantity of ' + esc(l.title) + '">−</button>' +
        '<span aria-live="polite">' + l.qty + '</span><button type="button" data-cv-qty="1" data-key="' + esc(l.key) + '" aria-label="Increase quantity of ' + esc(l.title) + '">+</button></div>' +
        '<button type="button" class="cv-remove" data-cv-remove data-key="' + esc(l.key) + '">Remove</button></div><p class="cv-line-price">' + esc(money(l.line)) + '</p></li>';
    }).join('') + '</ul>' + recs(cart);
    var disc = cart.discounts.map(function (d) { return '<div class="cv-row cv-disc"><span>' + esc(d.title) + '</span><span>−' + esc(money(d.amount)) + '</span></div>'; }).join('');
    var checkout = C.checkoutOpen
      ? '<a class="button button-dark cv-checkout" href="' + esc((C.routes && C.routes.checkout) || '/checkout') + '" data-cv-checkout>Checkout · ' + esc(money(cart.total)) + '</a>'
      : '<span class="button button-dark cv-checkout" role="button" aria-disabled="true">Checkout opens soon</span>';
    foot.innerHTML = disc + '<div class="cv-row cv-sub" aria-live="polite"><span>Subtotal</span><strong>' + esc(money(cart.subtotal)) + '</strong></div>' +
      '<p class="cv-note">' + esc(C.trust && C.trust.shipping ? C.trust.shipping + ' ' : '') + 'Taxes, if any, are shown at checkout.</p>' + checkout +
      (demo ? '<p class="cv-note">Demo bag with example prices. Checkout is not open.</p>' : '') +
      '<button type="button" class="text-button cv-continue" data-cv-close>Continue shopping</button>';
    updateBadges(cart);
  };
  var updateBadges = function (cart) {
    document.querySelectorAll('[data-cv-bag-count]').forEach(function (el) { el.textContent = cart.count; });
  };
  var refresh = function (p) { return (p || Cart.get()).then(function (c) { renderDrawer(c); return c; }).catch(function () { /* keep the last rendered state */ }); };
  var focusables = function () { return Array.prototype.slice.call(panel.querySelectorAll('a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])')); };
  var openDrawer = function () {
    if (!drawer) return;
    lastFocus = document.activeElement;
    drawer.hidden = false; document.documentElement.classList.add('cv-lock');
    requestAnimationFrame(function () { drawer.classList.add('is-open'); panel.querySelector('.cv-close').focus(); });
    refresh().then(function (c) { if (c) track('view_cart', { value: c.total, currency: C.currency, items: c.count }); });
  };
  var closeDrawer = function () {
    if (!drawer || drawer.hidden) return;
    drawer.classList.remove('is-open'); document.documentElement.classList.remove('cv-lock');
    setTimeout(function () { drawer.hidden = true; }, 260);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  };
  var buildDrawer = function () {
    drawer = document.createElement('div');
    drawer.className = 'cv-drawer'; drawer.hidden = true;
    drawer.innerHTML = '<div class="cv-scrim" data-cv-close></div><aside class="cv-panel" role="dialog" aria-modal="true" aria-labelledby="cv-title">' +
      '<header class="cv-head"><h2 id="cv-title">Your bag <span data-cv-count></span></h2><button type="button" class="cv-close" data-cv-close aria-label="Close bag">×</button></header>' +
      '<div class="cv-body"></div><footer class="cv-foot"></footer></aside>';
    document.body.appendChild(drawer);
    panel = drawer.querySelector('.cv-panel');
    drawer.addEventListener('click', function (e) {
      var t = e.target;
      if (t.closest('[data-cv-close]')) { closeDrawer(); return; }
      var q = t.closest('[data-cv-qty]'), rm = t.closest('[data-cv-remove]'), rec = t.closest('[data-cv-rec]'), co = t.closest('[data-cv-checkout]');
      if (q || rm) {
        var key = (q || rm).getAttribute('data-key');
        Cart.get().then(function (c) {
          var line = c.lines.filter(function (l) { return l.key === key; })[0]; if (!line) return;
          var qty = rm ? 0 : Math.max(0, line.qty + Number(q.getAttribute('data-cv-qty')));
          return refresh(Cart.change(key, qty));
        });
      } else if (rec) {
        var h = rec.getAttribute('data-cv-rec'), p = product(h);
        refresh(Cart.add([{ handle: h, variant: p && p.variantId, qty: 1 }])).then(function () { track('add_to_cart', { item: h, source: 'bag_recommendation' }); });
      } else if (co) { track('begin_checkout', {}); }
    });
    drawer.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { closeDrawer(); return; }
      if (e.key !== 'Tab') return;
      var f = focusables(); if (!f.length) return;
      if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
      else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
    });
  };
  // Theme: the bag drawer works with the real Shopify cart whenever it is enabled; prototype: only while orders are open.
  var drawerOn = !!C.cartDrawer && (isShopify || !!C.ordersOpen);
  if (drawerOn) {
    buildDrawer();
    // Bag triggers: links to the cart page open the drawer instead; the product page gets a bag button.
    document.querySelectorAll('a[href$="cart.html"], a[href="/cart"], [data-cv-open-bag]').forEach(function (a) {
      a.addEventListener('click', function (e) { e.preventDefault(); openDrawer(); });
    });
    var head = document.querySelector('.site-head');
    if (head && !head.querySelector('[data-cv-open-bag], a[href$="cart.html"], a[href="/cart"]')) {
      var bag = document.createElement('button');
      bag.type = 'button'; bag.className = 'saved-trigger cv-bag-btn'; bag.setAttribute('data-cv-open-bag', '');
      bag.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 8h12l-1 12H7zM9 8a3 3 0 0 1 6 0"/></svg><span class="saved-label">Bag</span><span class="saved-count" data-cv-bag-count>0</span>';
      bag.setAttribute('aria-label', 'Open bag');
      bag.addEventListener('click', openDrawer);
      var saved = head.querySelector('.saved-trigger'); head.insertBefore(bag, saved || null);
    }
    Cart.get().then(updateBadges).catch(function () {});
  }

  // ---------- email capture (prepared; never submits until a consented email service is connected)
  var emailEl = document.querySelector('[data-cv-email]');
  if (emailEl && C.email && C.email.enabled && C.email.title) {
    emailEl.innerHTML = '<h2 id="cv-email-title">' + esc(C.email.title) + '</h2>' + (C.email.text ? '<p>' + esc(C.email.text) + '</p>' : '') +
      '<form onsubmit="return false"><label class="visually-hidden" for="cv-email-input">Email address</label><input id="cv-email-input" type="email" autocomplete="email" placeholder="Email address" disabled><button class="button button-dark" type="submit" disabled>Sign up</button></form>' +
      '<small>' + (demo ? 'Demo: sign-up is prepared but not collecting emails.' : 'Sign-up opens soon.') + '</small>';
    emailEl.hidden = false;
  }

  // ---------- product page purchase block
  var pdp = document.querySelector('[data-cv-pdp]');
  if (!pdp) return;
  var handle = pdp.getAttribute('data-handle') || C.product, P = product(handle);
  if (!P) return;
  var offer = offerState(handle);
  var variantId = function () {
    var input = pdp.querySelector('input[data-variant-id]'); if (input && input.value) return input.value; // theme: the product form's selected variant
    var on = document.querySelector('.finish-picker [aria-checked="true"]'); return on ? (on.getAttribute('data-variant-id') || on.getAttribute('data-finish')) : '';
  };
  var variant = function () { var id = variantId(); return (P.variants || []).filter(function (v) { return String(v.id) === String(id); })[0]; };
  var unitPrice = function () { var v = variant(); var vp = v && num(v.price); return vp > 0 ? vp : num(P.price); };

  // Launch offer: previous price, calculated saving, end date and terms (no countdown).
  var priceEl = pdp.querySelector('[data-cv-price]'), offerEl = pdp.querySelector('[data-cv-offer]');
  if (offer && priceEl) {
    priceEl.innerHTML = '<s class="promo-was" aria-label="Previous price ' + esc(money(offer.was)) + '">' + esc(money(offer.was)) + '</s><span class="price-v">' + esc(money(offer.price)) + '</span><span class="price-c">' + esc(C.currency) + '</span><span class="cv-save">Save ' + offer.pct + '%' + (offer.endsToday ? ' today' : '') + '</span>';
  }
  if (offer && offerEl) {
    offerEl.innerHTML = '<p class="cv-offer-label">' + esc(offer.label) + '</p><p class="cv-offer-ends">Ends ' + esc(offer.ends) + '</p>' + (offer.terms ? '<p class="cv-offer-terms">' + esc(offer.terms) + '</p>' : '');
    offerEl.hidden = false;
  }

  // Genuine low-stock note: only with tracked stock at or below the threshold; nothing otherwise.
  var stockEl = pdp.querySelector('[data-cv-stock]');
  var renderStock = function () {
    if (!stockEl) return;
    var v = variant(), t = C.lowStock || {};
    var n = v && typeof v.stock === 'number' ? v.stock : null;
    if (t.enabled && n !== null && n > 0 && n <= (t.threshold || 0)) { stockEl.textContent = t.showCount === false ? 'Low stock in ' + v.title + '.' : 'Only ' + n + ' left in ' + v.title + '.'; stockEl.hidden = false; }
    else if (t.enabled && n === 0) { stockEl.textContent = v.title + ' is sold out.'; stockEl.hidden = false; }
    else stockEl.hidden = true;
  };

  // Trust copy: only supplier-confirmed delivery ranges and the published returns policy replace the defaults.
  if (C.trust) {
    var td = document.querySelector('[data-cv-trust="delivery"]'), tr = document.querySelector('[data-cv-trust="returns"]');
    if (td && C.trust.delivery) td.textContent = 'Included in the price. ' + C.trust.delivery;
    if (tr && C.trust.returns) tr.textContent = C.trust.returns;
  }

  var ordersOpen = isShopify ? pdp.getAttribute('data-cv-orders-open') === 'true' : !!C.ordersOpen;
  if (!ordersOpen) { renderStock(); track('view_item', { item: handle }); return; }

  // Purchase options (single piece or a set) and optional add-ons.
  var optEl = pdp.querySelector('[data-cv-options]'), addEl = pdp.querySelector('[data-cv-addons]');
  var bundles = (C.bundles || []).map(function (b) { return { b: b, st: bundleState(b) }; }).filter(function (x) { return x.st && x.b.items.indexOf(handle) !== -1; });
  if (optEl && bundles.length) {
    optEl.innerHTML = '<fieldset><legend class="opt-label">Purchase options</legend>' +
      '<label class="cv-opt"><input type="radio" name="cv-opt" value="single" checked><span><strong>' + esc(P.title) + '</strong><em data-cv-single-price></em></span></label>' +
      bundles.map(function (x) {
        return '<label class="cv-opt"><input type="radio" name="cv-opt" value="' + esc(x.b.id) + '"><span><strong>' + esc(x.b.title) + '</strong><small>' + esc(x.b.text || '') + '</small>' +
          '<em>' + (x.st.saving ? '<s>' + esc(money(x.st.sum)) + '</s> ' : '') + esc(money(x.st.price)) + (x.st.saving ? ' · Save ' + esc(money(x.st.saving)) : '') + '</em></span></label>';
      }).join('') + '</fieldset>';
    optEl.hidden = false;
  }
  var addons = ((C.addOns && C.addOns.enabled && C.addOns.products) || []).filter(function (h) { return h !== handle && product(h) && num(product(h).price) > 0; });
  if (addEl && addons.length) {
    addEl.innerHTML = '<fieldset><legend class="opt-label">' + esc(C.addOns.title || 'Add to your ritual') + '</legend>' + addons.map(function (h) {
      var p = product(h); return '<label class="cv-addon"><input type="checkbox" value="' + esc(h) + '"><img src="' + esc(p.image) + '" alt=""><span>' + esc(p.title) + '</span><em>+ ' + esc(money(num(p.price))) + '</em></label>';
    }).join('') + '</fieldset>';
    addEl.hidden = false;
  }

  // Primary CTA and the mobile sticky bar mirror the same total.
  pdp.querySelectorAll('[data-cv-closed]').forEach(function (el) { el.hidden = true; });
  var addBtn = pdp.querySelector('[data-cv-add]'), sticky = document.querySelector('.sticky-buy');
  var qtyRow = pdp.querySelector('[data-cv-qty-row]'), qtyInput = pdp.querySelector('[data-cv-qty-input]'), buyBtn = pdp.querySelector('[data-cv-buy]'), live = pdp.querySelector('[data-cv-live]');
  if (qtyRow) qtyRow.hidden = false;
  var qty = function () { var n = qtyInput ? parseInt(qtyInput.value, 10) : 1; n = isFinite(n) ? Math.min(10, Math.max(1, n)) : 1; if (qtyInput && String(n) !== qtyInput.value) qtyInput.value = n; return n; };
  if (qtyRow) qtyRow.addEventListener('click', function (e) { var b = e.target.closest('[data-cv-q]'); if (!b || !qtyInput) return; qtyInput.value = Math.min(10, Math.max(1, qty() + Number(b.getAttribute('data-cv-q')))); renderCta(); });
  var say = function (msg) { if (live) { live.textContent = ''; setTimeout(function () { live.textContent = msg; }, 30); } };
  var selection = function () {
    var opt = (optEl && optEl.querySelector('input[name="cv-opt"]:checked') || {}).value || 'single';
    var total = 0, items = [], q = qty(), b = bundles.filter(function (x) { return x.b.id === opt; })[0];
    if (b) { total += b.st.price * q; b.b.items.forEach(function (h) { var p = product(h); items.push({ handle: h, variant: h === handle ? variantId() : (p && p.variantId), qty: q, bundle: b.b.id }); }); }
    else { total += unitPrice() * q; items.push({ handle: handle, variant: variantId(), qty: q }); }
    (addEl ? Array.prototype.slice.call(addEl.querySelectorAll('input:checked')) : []).forEach(function (i) { var p = product(i.value); total += num(p.price); items.push({ handle: i.value, variant: p.variantId, qty: 1 }); });
    return { total: total, items: items };
  };
  var soldOut = function () { var v = variant(); return v && v.stock === 0; };
  var renderCta = function () {
    var s = selection(), out = soldOut();
    var label = out ? 'Sold out' : 'Add to bag · ' + money(s.total);
    if (addBtn && !addBtn.classList.contains('is-added')) { addBtn.hidden = false; addBtn.disabled = out; addBtn.textContent = label; }
    if (buyBtn) buyBtn.disabled = out;
    var sp = optEl && optEl.querySelector('[data-cv-single-price]'); if (sp) sp.textContent = money(unitPrice());
    if (sticky) {
      var v = variant();
      sticky.querySelector('.sb-name').innerHTML = esc(P.title) + '<small>' + esc((v ? v.title + ' · ' : '') + money(s.total)) + '</small>';
      var sb = sticky.querySelector('.button'); sb.textContent = out ? 'Sold out' : 'Add to bag'; sb.removeAttribute('aria-disabled');
      if (sb.tagName === 'A') sb.setAttribute('role', 'button');
      sticky.removeAttribute('aria-hidden');
    }
    renderStock();
  };
  var add = function () {
    if (soldOut()) return;
    var s = selection();
    var btns = [addBtn, sticky && sticky.querySelector('.button')].filter(Boolean);
    btns.forEach(function (b) { b.setAttribute('aria-busy', 'true'); });
    (drawerOn ? refresh(Cart.add(s.items)) : Cart.add(s.items)).then(function () {
      btns.forEach(function (b) { b.removeAttribute('aria-busy'); });
      track('add_to_cart', { item: handle, value: s.total, currency: C.currency, lines: s.items.length });
      if (addBtn) { addBtn.classList.add('is-added'); addBtn.textContent = 'Added to bag ✓'; setTimeout(function () { addBtn.classList.remove('is-added'); renderCta(); }, 1800); }
      say('Added to your bag.');
      try { document.dispatchEvent(new CustomEvent('ssr:added', { detail: { item: handle, lines: s.items.length } })); } catch (x) { /* old browsers */ }
      if (drawerOn) openDrawer(); else location.href = (C.routes && C.routes.cart) || 'cart.html';
    }).catch(function () { btns.forEach(function (b) { b.removeAttribute('aria-busy'); }); });
  };
  var nativeForm = pdp.querySelector('form[data-product-form]');
  if (nativeForm && drawerOn) nativeForm.addEventListener('submit', function (e) { e.preventDefault(); add(); }); // theme: Ajax add + drawer
  else if (addBtn && addBtn.type !== 'submit') addBtn.addEventListener('click', add);
  // Theme: its own sticky button already submits the product form, so only the prototype bar is wired here.
  if (sticky && !sticky.querySelector('[data-sticky-add]')) { var sbtn = sticky.querySelector('.button'); sbtn.addEventListener('click', function (e) { e.preventDefault(); add(); }); sbtn.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); add(); } }); if (sbtn.tagName === 'A') sbtn.tabIndex = 0; }
  // Buy now: straight to Shopify's checkout with this exact selection (cart permalink variant:quantity), never around it.
  if (buyBtn) {
    buyBtn.hidden = false;
    buyBtn.addEventListener('click', function () {
      if (soldOut()) return;
      var s = selection();
      if (isShopify && C.checkoutOpen) {
        track('begin_checkout', { value: s.total, currency: C.currency, source: 'buy_now' });
        var base = (C.routes && C.routes.root) || '/'; if (base.slice(-1) !== '/') base += '/';
        location.href = base + 'cart/' + s.items.map(function (i) { return i.variant + ':' + i.qty; }).join(',');
      } else say('Checkout opens soon. Buy now will go straight to secure checkout with this selection.');
    });
  }
  // Complete your ritual: add a recommended piece directly to the bag.
  document.querySelectorAll('[data-cv-rel-add]').forEach(function (b) {
    var card = b.closest('[data-handle]'), h = card && card.getAttribute('data-handle'), p = product(h);
    if (!p || !(num(p.price) > 0)) return;
    b.hidden = false;
    b.addEventListener('click', function () {
      var items = [{ handle: h, variant: p.variantId, qty: 1 }];
      (drawerOn ? refresh(Cart.add(items)) : Cart.add(items)).then(function () {
        b.textContent = 'Added ✓'; setTimeout(function () { b.textContent = 'Add to bag'; }, 1600);
        say(p.title + ' added to your bag.'); track('add_to_cart', { item: h, source: 'complete_your_ritual' });
        try { document.dispatchEvent(new CustomEvent('ssr:added', { detail: { item: h, lines: 1 } })); } catch (x) { /* old browsers */ }
        if (drawerOn) openDrawer();
      });
    });
  });
  if (qtyInput) qtyInput.addEventListener('input', renderCta);
  pdp.addEventListener('change', renderCta);
  document.querySelectorAll('.finish-picker [role="radio"], [data-option-index]').forEach(function (b) { b.addEventListener('click', function () { setTimeout(renderCta, 30); }); });
  renderCta();
  track('view_item', { item: handle, value: unitPrice(), currency: C.currency });
})();
